const dict = new Map<any, number>()

let serial = 0

export function id(a: any) {
  if (dict.has(a)) {
    return dict.get(a)!
  } else {
    const current = ++serial
    dict.set(a, current)
    return current
  }
}
